export const SectionHeader = ({ eyebrow, title, subtitle, align = 'left' }) => (
  <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    {eyebrow && (
      <div className="text-[11px] uppercase tracking-[0.24em] text-[#00b4d8] font-semibold mb-3">{eyebrow}</div>
    )}
    <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-white">{title}</h2>
    {subtitle && <p className="mt-4 text-white/65 text-base leading-relaxed">{subtitle}</p>}
  </div>
);
